import {useShallow} from 'zustand/react/shallow';
import contentLabStore from '@contentlab/stores/contentLabStore';
import {FeatureName} from '@contentlab/types/project';

function useFeatureAssets(feature: FeatureName | string) {
  const {uploadedVideos, uploadingFiles, assetErrors} = contentLabStore(
    useShallow((state) => ({
      uploadedVideos: state.uploadedVideos.filter(
        (video) => video.feature === feature
      ),
      uploadingFiles: Object.fromEntries(
        Object.entries(state.uploadingFiles).filter(
          ([, file]) => file.feature === feature
        )
      ),
      assetErrors: state.assetErrors.filter(
        (assetError) => assetError.feature === feature
      ),
    }))
  );

  return {uploadedVideos, uploadingFiles, assetErrors};
}

export default useFeatureAssets;
